<li class="list-group-item justify-content-between border-left-0 border-right-0 border-top-0">
    <div class="p-0">
        <strong>
            @if (metadataItem.url) {
            <a href="{{metadataItem.url}}" title="{{metadataItem.url}}" target="_blank">{{metadataItem.name}}</a>
            }
            @if (!metadataItem.url) {
            <span>{{metadataItem.name}}</span>
            }
        </strong>
        <p class="text-muted">{{metadataItem.value}}</p>
    </div>
</li>




